import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PlusIcon from "../components/common/Icons/PlusIcon";
import PageHeader from "../components/common/PageHeader";
import DepartmentSettingsTable from "../components/Settings/Department/DepartmentSettingsTable";
import ContractSettingsTable from "../components/Settings/Contract/ContractSettingsTable";

const ContractSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Container>
      <PageHeader
        pageTitle="Kontrat Listesi"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Kontrat"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <ContractSettingsTable />
    </Container>
  );
};

export default ContractSettings;
